
import { WaxeyeCompiler } from '../../../lib/waxeye-compiler/racketscript-waxeye-compiler.js';
import { WaxeyeParser } from '../../../lib/waxeye-javascript/waxeye.js';
export {WaxeyeParser, WaxeyeCompiler};

export function makeParser(grammar: string): WaxeyeParser {
    const result = WaxeyeCompiler.generateParser(grammar);
    if (!result[0]) throw result[1];
    const data = result[0] as string[];
    return new WaxeyeParser(JSON.parse(`${data[2]}`), data[1])
}
